const FONT = 'Helvetica';
const headerHeight = 0;
const topBarHeight = 0;
const headerInfoHeight = 0 + topBarHeight;
const tableHeaderHeight = 0;
const tableWidth = 750;
const headerWidth = tableWidth + 50;
const cellWidth = tableWidth / 11 - 28;
const rowHeight = 30;

export default {
  container: {
    marginTop: 0,
    height: 'calc(94vh - 115px)',
    backgroundColor: '#D3D3D3',
    display: 'flex',
    flexDirection: 'column',
  },

  containerMobile: {
    marginTop: 0,
    height: 'calc(100vh - 80px)',
    backgroundColor: '#D3D3D3',
    display: 'flex',
    flexDirection: 'column',
  },
  visiblediv: {
    width: '100%',
    flex: 1,
    overflow: 'auto',
  },
  visiblelink: {
    background: '#fff',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '30px',
  },
  optionsBoardContainer: {
    display: 'flex',
    height: 'calc(100%)',
    backgroundColor: '#D3D3D3',
  },
  mobileOptionsBoardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    width: '100%',
  },
  leftContainer: {
    width: '100%',
    zIndex: 1,
    left: 0,
    backgroundColor: '#D3D3D3',
  },
  // NK
  leftSuperContainer: {
    paddingTop: '30px',
    backgroundColor: '#D3D3D3',
    height: '90%',
  },
  // NK
  calenderContainer: {
    backgroundColor: 'blue',
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tickerContainer: {
    marginBottom: '11%',
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftGreendiv: {
    height: 'calc((100% - 200px))',
    backgroundColor: '#043055',
    marginLeft: 30,
    marginRight: 30,
  },
  midContainer: {
    zIndex: 999,
    height: '65%',
    backgroundColor: '#043055',
  },
  lowLeftContainer: {
    zIndex: 100,
    boxSizing: 'border-box',
    height: '35%',
    backgroundColor: '#043055',
    overflowY: 'auto',
    position: 'relative',
  },
  paperContainer: {
    width: '100%',
    margin: 'auto',
    marginTop: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
  },
  middletopdiv: {
    flex: 1,
  },
  paperContainerMobile: {
    width: '100%',
    margin: 'auto',
    marginTop: 0,
    marginBottom: 75,
    paddingBottom: 20,
    minHeight: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    overflow: 'none',
  },
  warningsContainer: {
    backgroundColor: '#D3D3D3',
  },
  articlesFixed: {
    overflowY: 'scroll',
    backgroundColor: 'white',
    marginRight: '30px',
    marginLeft: '30px',
    height: 'calc(100% - 325px)',
    fontSize: '0.85rem',
  },
  articlesTitleFixed: {
    fontSize: '1.17em',
    fontWeight: 'bold',
    marginRight: '30px',
    marginLeft: '30px',
    height: '20px',
    paddingTop: '20px',
    paddingBottom: '10px',
  },
  stockPaper: {
    zIndex: 10,
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '10px',
    height: '100%',
  },
  stockContainer: {
    marginRight: '30px',
    marginLeft: '30px',
    background: 'white',
    width: 'calc(100% - 60px)',
    height: '275px',
  },
  warningsWrapper: {
    top: headerHeight + topBarHeight + 250, // 250 is height of tradingview chart
    margin: 'auto',
  },
  warningPaper: {
    backgroundColor: 'rgb(180,26,0)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: 'auto',
    padding: 10,
    position: 'relative',
    marginBottom: 10,
    width: '275px',
    fontSize: '0.875rem',
  },
  warningIcon: {
    height: 30,
  },
  headerCell: {
    textColor: 'black',
    fontWeight: 'bold',
    padding: '0 5px',
    borderRight: '1px solid #e0e0e0',
    backgroundColor: '#bababa',
    top: '27px',
    fontSize: '0.875rem',
  },
  warningRightSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  warningText: {
    color: 'white',
    fontFamily: FONT,
    marginRight: 20,
    fontSize: '0.875rem',
  },
  closeButton: {
    position: 'absolute',
    height: 30,
    width: 30,
    right: 0,
    top: 0,
    color: 'white',
  },
  moreInfoButton: {
    fontSize: 14,
    color: 'white',
    margin: 'auto',
  },

  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    overflow: 'none',
    width: '100%',
  },
  basicFlexContainerCall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
    width: '100%',
  },
  basicFlexContainerPut: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
    width: '100%',
  },
  basicFlexContainerCallMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
    width: '100%',
    margin: 'auto',
    minWidth: 220,
  },
  basicFlexContainerPutMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
    width: '100%',
    margin: 'auto',
    minWidth: 150,
  },
  fixedhead: {
    top: headerInfoHeight + headerHeight,
  },
  callsHeaderFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'black',
    zIndex: 998,
    height: '50px',
    width: '100%',
  },
  callstableheader: {
    top: headerInfoHeight + headerHeight,
    height: '30px',
    width: '100%',
  },
  callsHeaderFlexContainerMobile: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingLeft: 30,
    paddingRight: 60,
    boxSizing: 'border-box',
    alignItems: 'center',
    top: headerInfoHeight + headerHeight,
    background: 'black',
    zIndex: 998,
    height: '50px',
  },
  advancedHeaderFlexContainer: {
    height: '50px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: 12,
    top: headerInfoHeight + headerHeight,
    background: 'black',
    zIndex: 998,
  },
  callsHeader: {
    fontFamily: FONT,
    color: 'white',
  },

  putsHeaderFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: 40,
    top: headerInfoHeight + headerHeight,
    background: 'black',
    zIndex: 998,
    height: '50px',
  },
  putsHeader: {
    fontFamily: FONT,
    color: 'white',
  },
  advancedBoardContainer: {
    width: '100%',
    maxWidth: tableWidth - 40,
    margin: 'auto',
    position: 'relative',
  },
  modalDate: { margin: '0px', color: 'grey', marginTop: '5px' },
  crossIconMOdal: {
    position: 'absolute',

    top: `5%`,
    right: `5%`,
    transform: `translate(-50%, -50%)`,
    backgroundColor: 'white',
    padding: '5px',
    overflowY: 'auto',
  },
  Modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '83%',
    width: '50%',
    backgroundColor: 'white',
    padding: '5px',
    overflowY: 'auto',
  },

  basicBoardsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  basicBoardsWrapperMobile: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    width: '100%',
    justifyContent: 'center',
  },
  basicBoardsWrappeInput: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    width: '100%',
    justifyContent: 'center',
    backgroundColor: '#043055',
  },
  tableRow: {
    height: rowHeight,
  },
  modalTableRow: {
    height: 15,
    borderStyle: 'solid',
    borderWidth: '1px',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    borderColor: '#C0C0C0',
    textAlign: 'center',
  },
  modalTableRowGray: {
    background: '#D3D3D3',
    padding: '2px 6px 2px 6px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#C0C0C0',
    minWidth: '50px',
    textAlign: 'center',
  },
  modalTableRowYellow: {
    padding: '2px 6px 2px 6px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#C0C0C0',
    background: '#FCFFCC',
    textAlign: 'center',
  },
  advancedBoardRow: {
    height: rowHeight,
  },
  strikeCell: {
    background: 'rgb(60, 60, 60)',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(240,240,240)',
    borderColor: 'rgb(150,150,150)',
  },
  RRCell: {
    background: '#FFFCD1',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
  },
  tableCell: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    background: 'rgb(255,255,255)',
    color: 'rgb(0,0,0)',
    width: cellWidth,
    textAlign: 'center',
  },
  shadedTableCell: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(100,100,100)',
    background: 'rgb(255,255,255)',
    borderColor: 'rgb(165,165,165)',
    opacity: 0.5,
  },
  tableCellClickable: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    background: 'rgba(95,105,175, 0.5)',
    opacity: 1,
    color: 'rgb(0,0,0)',
    width: cellWidth,
    textAlign: 'center',
    cursor: 'pointer',
  },
  shadedTableCellClickable: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: '#000',
    background: 'rgba(200,200,255,1)',
    borderColor: 'rgb(165,165,165)',
    opacity: 0.5,
    cursor: 'pointer',
    '&:hover': { background: 'rgba(255,255,255,1)', opacity: 1 },
  },
  tableCellClickableMobile: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    background: 'rgba(235 ,238, 255)',
    opacity: 1,
    color: 'rgb(0,0,0)',
    width: cellWidth,
    textAlign: 'center',
    cursor: 'pointer',
  },
  shadedTableCellClickableMobile: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: '#000',
    background: 'rgba(175 ,183, 210,1)',
    borderColor: 'rgb(165,165,165)',
    opacity: 1,
    cursor: 'pointer',
    '&:hover': { background: 'rgba(255,255,255,1)', opacity: 1 },
  },

  greenTableCell: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(0,0,0)',
    background: 'rgb(194,237,188)',
    opacity: 0.8,
  },
  strikeHeaderCell: {
    background: 'rgb(65, 65, 65)',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    color: '#FFFFF0',
    zIndex: 4,
  },
  advancedStrikeHeaderCell: {
    background: 'rgb(65, 65, 65)',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    color: '#FFFFF0',
    zIndex: 4,
  },
  RRHeaderCell: {
    background: '#FFF56D',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(0, 0, 0, 0.87)',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    zIndex: 4,
  },
  greenHeaderCell: {
    background: 'rgb(194,237,188)',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(0, 0, 0, 0.87)',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    zIndex: 4,
  },
  tableHeaderCell: {
    background: '#FFF',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(0, 0, 0, 0.87)',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    zIndex: 5,
  },
  modalTableHeaderCell: {
    background: '#043055',
    color: 'white',
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    zIndex: 5,
  },
  advancedCallButton: {
    margin: 'auto',
    marginTop: 15,
    marginBottom: 15,
  },
  advancedPutButton: {
    margin: 'auto',
    marginTop: 15,
    marginBottom: 15,
    marginRight: 70,
  },
  advancedHeader: {
    fontFamily: FONT,
    color: 'white',
    background: '#fff',
    textAlign: 'center',
    top: headerInfoHeight + headerHeight,
    padding: 12,
  },
  backButton: {
    marginLeft: 20,
  },
  headerInfo: {
    background: '#fff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    top: headerHeight + topBarHeight,
    height: 120,
    maxWidth: tableWidth,
    width: '100%',

    margin: 'auto',
    zIndex: 999,
  },
  headerInfoMobile: {
    background: '#fff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%', // Makes the header as wide as the calls/puts table below.
    height: '80px',
    margin: 'auto',
    zIndex: 1000,
  },
  stockPriceInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  stockPrice: {
    fontSize: 16,
  },
  stockPriceMobile: {
    fontSize: 13,
  },
  selectors: {
    width: headerWidth / 3,
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    justifyContent: 'space-around',
  },
  selectorsMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    boxShadow: 'none',
    padding: '10px',
    boxSizing: 'border-box',
    borderRadius: 0,
  },
  thirdSelector: {
    width: headerWidth / 3,
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    justifyContent: 'space-around',
    background: '#FFF',
  },
  selectorsFlex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignContent: 'center',
    width: '100%',
  },
  selectorsFlexCenter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignContent: 'center',
    width: '100%',
    alignItems: 'center',
  },
  selectorText: {
    fontSize: 13,
    fontWeight: 'bold',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  confidenceHeader: {
    textAlign: 'center',
  },
  sliderItem: {
    width: '40%',
  },
  progressBarContainer: {
    width: '60%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  progressBarIVContainer: {
    width: '61.5%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  progressBar: {
    backgroundColor: '#1176b8',
    width: '100%',
  },
  progressLabelTextLeft: { marginRight: 2 },
  progressLabelTextRight: { marginLeft: 2 },
  inputItem: {
    width: '35%',
    fontSize: 13,
    paddingLeft: 8,
    paddingRight: 8,
  },
  expirationInputBasic: {
    width: 100,
    textAlign: 'right',
    fontSize: 12,
    top: 10,
    right: 0,
    position: 'absolute',
    background: 'white',
    zIndex: 1001,
    display: 'block',
    height: tableHeaderHeight / 2,
  },
  expirationInputBasicMobile: {
    width: 85,
    textAlign: 'right',
    fontSize: 10,
    top: 10,
    right: 0,
    position: 'absolute',
    background: 'white',
    zIndex: 1001,
    display: 'block',
    height: tableHeaderHeight / 2,
  },
  expirationInputAdvanced: {
    width: 100,
    textAlign: 'right',
    fontSize: 10,
    top: 10,
    left: 10,
    background: 'white',
    zIndex: 1001,
    height: tableHeaderHeight / 2,
    position: 'absolute',
  },

  tooltip: {
    maxWidth: 350,
    overflow: 'wrap',
  },
  earningtooltip: {
    maxWidth: 200,
    overflow: 'wrap',
    color: '#fff',
    fontSize: '16px',
  },
  posPriceChange: {
    color: 'green',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    fontSize: 13,
    marginBottom: 0,
    height: '14px',
  },
  negPriceChange: {
    color: 'red',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    fontSize: 13,
    marginBottom: 0,
    height: '14px',
  },
  downArrow: {
    color: 'red',
    marginBottom: -10,
    marginRight: -5,
    fontSize: 30,
  },
  downArrowMobile: {
    color: 'red',
    marginBottom: -5,
    marginRight: -5,
    marginLeft: -8,
    fontSize: 30,
  },
  upArrow: {
    color: 'green',
    marginBottom: -5,
    marginRight: -5,
    fontSize: 30,
  },
  upArrowMobile: {
    color: 'green',
    marginBottom: -5,
    marginRight: -5,
    marginLeft: -8,
    fontSize: 30,
  },
  priceChange: {
    marginRight: 3,
  },
  timestampText: {
    fontSize: 10,
  },
  premiumSelect: {
    fontSize: 12,
    fontFamily: FONT,
  },
  flexRowStart: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  basicWrapperMobile: {
    display: 'block',
    margin: 'auto',
    overflow: 'auto',
    height: '100%',
  },
  basicWrapper: {
    display: 'block',
    position: 'relative',
    margin: 'auto',
    overflow: 'auto',
    height: 'calc(100% - 120px)',
    width: '98%',
  },
  advancedWrapper: {
    display: 'block',
    margin: 'auto',
    overflow: 'auto',
    height: 'calc(100% - 120px)',
    width: '100%',
  },
  advancedWrapperMobile: {
    display: 'block',
    margin: 'auto',
    overflow: 'auto',
    height: '100%',
    width: '100%',
  },

  companyText: {
    fontSize: 19,
  },
  circularSpinner: {
    marginLeft: 5,
  },
  shadedRow: {
    background: 'rgb(0,0,0)',
    height: rowHeight,
  },
  shadedRRCell: {
    background: 'rgb(255,252,209)',
    opacity: 0.5,
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(100,100,100)',
    borderColor: 'rgb(165,165,165)',
  },
  shadedStrikeCell: {
    background: 'rgb(70,70,70)',
    opacity: 0.5,
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(255,255,255)',
    borderColor: 'rgb(120,120,120)',
  },
  shadedGreenCell: {
    background: 'rgb(194,237,188)',
    opacity: 0.5,
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    color: 'rgb(100,100,100)',
    borderColor: 'rgb(165,165,165)',
  },
  bigH: {
    fontSize: 20,
    fontWeight: 'bold',
    margin: 1,
    marginRight: -17,
  },

  hideShadingBox: {
    position: 'absolute',
    right: 5,
    top: 9,
    width: 55,
    height: 30,
    backgroundColor: 'gray',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  removeShadingText: {
    fontSize: 10,
    lineHeight: 1.3,
    color: 'lightgray',
  },

  topBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: 'rgb(8, 65, 113)',
    height: '50px',
    width: '100%',
    zIndex: 1000,
  },
  dateSelectContainer: {
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spaan: { marginTop: '12px', fontSize: '14px', color: 'white' },
  calenderOB: {
    height: '30px',
    display: 'flex',
    padding: '6px 0 5px 10px',
    justifyContent: 'start',
    alignItems: 'start',
    background: 'rgb(8, 65, 113)',
    margin: '0px 30px',
  },
  strikeOB: {
    height: '40px',
    display: 'flex',
    color: 'white',
    zIndex: 998,
    top: '0px',
    padding: '0 0 1px 10px',
    justifyContent: 'start',
    alignItems: 'start',
    backgroundColor: 'rgb(8, 65, 113)',
  },

  expirationTitle: {
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    backgroundColor: 'black',
    color: '#FFFFFF',
    margin: '0px 30px',
  },

  expirationContainer: {},
  expirationTop: {
    height: '0px',
    position: 'sticky',
    top: '59px',
    right: '20px',
    color: 'white',
    textAlign: 'right',
    zIndex: '999',
    width: 'calc(100% + 7px)',
  },
  expirationTopMobile: {
    height: '0px',
    position: 'sticky',
    top: '16px',
    right: '20px',
    color: 'white',
    textAlign: 'right',
    zIndex: '999',
    width: 'calc(100% + 5px)',
    fontSize: '0.875rem',
  },
  tickerInput: {
    width: '200px',
    height: 28,
    fontSize: 18,
    fontFamily: FONT,
    color: 'gray',
    textAlign: 'center',
  },
  tickerInputMobile: {
    width: '200px',
    height: 24,
    fontSize: 16,
    fontFamily: FONT,
    color: 'gray',
    textAlign: 'center',
  },
  goButton: {
    marginLeft: 10,
    width: '50px',
    minWidth: 40,
    maxWidth: 40,
    background: 'green',
    color: 'white',
  },
  goButtonMobile: {
    marginLeft: 10,
    height: '30px',
    minWidth: 30,
    maxWidth: 30,
    background: 'green',
    color: 'white',
  },
  refreshButton: {
    marginTop: 5,
    height: 24,
    width: 30,
  },
  newOptionsChain: {
    marginRight: 25,
  },
  topBarRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  watchQuickVideo: {
    color: 'white',
  },
  playArrow: {
    color: 'white',
    marginRight: 10,
  },
  currentPriceArrowsContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  noTickerText: {
    fontStyle: 'italic',
    fontSize: 14,
  },
  shareLinkContainer: {},
  modalContainer: {},
  modalContent: {
    position: 'absolute',
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  },
  boardModalContent: {
    position: 'absolute',

    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    height: '83%',
    width: '50%',
    backgroundColor: 'white',
    padding: '5px',
    overflowY: 'auto',
  },
  boardModalContentMobile: {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    position: 'absolute',
    height: '80%',
    width: '95%',
    backgroundColor: 'white',
    padding: '0px',
    overflowY: 'auto',
  },
  boardModalHeader: {
    mariginLeft: '10%',
  },
  boardModalDataContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '20px',
    paddingBottom: '10px',
    maxWidth: '90%',
    width: '100%',
    margin: '0 auto',
  },
  boardModalDataLeft: {
    marginTop: '30px',
    paddingRight: '10px',
  },
  checkBoxText: { fontSize: '12px', marginBottom: '2.5px', fontWeight: 'bold' },
  boardModalDataRight: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    paddingTop: '10px',
  },
  modalCloseButtonMobile: {
    cursor: 'pointer',
    marginLeft: '90%',
    borderRadius: '50%',
    top: '0',
    padding: '8px',
    marginTop: '5px',
    position: 'fixed',
    background: '#fff',
    color: '#666',
    textAlign: 'center',
  },
  modalCloseButton: {
    cursor: 'pointer',
    marginLeft: '90%',
    borderRadius: '50%',
    top: '0',
    padding: '8px',
    marginTop: '20px',
    position: 'fixed',
    background: '#fff',
    color: '#666',
    textAlign: 'center',
  },
  boardModalBigGraph: {
    margin: 'auto',
    width: '90%',
    paddingBottom: '10px',
    marginBottom: 20,
    backgroundColor: 'black',
  },
  boardModalBigGraphMobile: {
    margin: 'auto',
    width: '100%',
    paddingBottom: '10px',
    marginBottom: 5,
    backgroundColor: 'black',
  },
  boardModalSmallGraph: {
    marginLeft: '5%',
    height: '150px',
    width: 'calc(90% - 30px)',
    marginBottom: 20,
    top: 0,
    background: '#fff',
  },
  boardModalSmallGraphMobile: {
    marginLeft: '10px',
    height: '200px',
    width: 'calc(100% - 35px)',
    marginBottom: 5,
    top: 0,
    background: '#fff',
  },
  boardModalTableContainer: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    margin: 'auto',
    width: '95%',
    maxHeight: 'calc(100% - 180px)',
  },
  stockDelayText: {
    fontSize: 12,
    color: 'gray',
    fontStyle: 'italic',
  },
  findEdgeContainer: {
    height: 50,
    background: '#1F4E79',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  clipboard: {
    height: '30px',
    width: '100%',
    textAlign: 'center',
    paddingTop: '0px',
    paddingBottom: '0px',
    boxSizing: 'border-box',
    background: 'white',
    cursor: 'pointer',
  },
  activeRow: {
    backgroundColor: 'blue',
  },
  inactiveRow: {},
  newsContainer: {
    height: '4rem',
    overflow: 'hidden',
    backgroundColor: 'white',
    marginRight: '15px',
    padding: '0.2rem',
  },
  leftNewsPic: {
    width: '35%',
    float: 'left',
    margin: '5px',
  },
  rightNews: {},

  mobileTopDetail: {
    width: '100%',
    background: 'white',
  },
  mobileTxExp: {
    color: 'white',
    backgroundColor: '#700606',
    padding: '3px 0px',
    textAlign: 'center',
    fontSize: '0.875rem',
    zIndex: 999,
  },
  divExps: {
    marginTop: '-1px',
    flex: 1,
    overflow: 'auto',
    background: 'rgb(4, 48, 85)',
  },
  premiumdiv: {
    width: '100%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
  premiumdivUoa: {
    width: '100%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
};



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/UOAModalStyles.js